module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.v) ? _c('div', {
    staticClass: "hidden-xs",
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "overlay-content",
    attrs: {
      "onclick": "event.stopPropagation();"
    }
  }, [_c('div', {
    staticClass: "age-content text-center"
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "src": "images/bignewlogo.png",
      "alt": "",
      "width": "150"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("A Bora Ital-nagykereskedelmi Kft. elkötelezett a kulturált italfogyasztás iránt."), _c('br'), _vm._v("\n                    Szeszesital fogyasztását 18 év alatt nem ajánljuk. ")]), _vm._v(" "), _c('h3', [_vm._v("Kérjük, adja meg életkorát!")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "age-button",
    on: {
      "click": _vm.accept
    }
  }, [_vm._v("Elmúltam 18 éves, belépek")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "age-button",
    on: {
      "click": _vm.decline
    }
  }, [_vm._v("Oldal elhagyása")])])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60d53ee0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/commons/util/AgeVerification.vue
// module id = 115
// module chunks = 0 1 2